































import { Component, Prop, Ref, Vue } from "vue-property-decorator";

import VModal from "@/components/VModal.vue";
import { ReportTemplate } from "@/models";
import {
  sanitizeReportName,
  validateReportName,
} from "@/services/ReportNameHelper";
import ReportNameField from "./ReportNameField.vue";
import { templateDisplayName } from "./reportTemplate";

@Component({
  components: {
    ReportNameField,
    VModal,
  },
})
export default class TemplateDuplicateModal extends Vue {
  @Prop({ default: null }) readonly template!: ReportTemplate | null;
  @Prop({ type: Boolean, default: false }) readonly duplicating!: boolean;

  @Ref("modal") readonly modal!: VModal;

  nameDraft = "";

  get displayName(): string {
    return this.template ? templateDisplayName(this.template) : "";
  }

  get nameDraftError(): string | null {
    return validateReportName(this.nameDraft);
  }

  get canConfirm(): boolean {
    return sanitizeReportName(this.nameDraft) !== null;
  }

  confirm() {
    const name = sanitizeReportName(this.nameDraft);
    if (!name || this.duplicating) return;
    this.$emit("confirm", name);
  }

  show() {
    this.nameDraft = "";
    this.modal.show();
  }

  hide() {
    this.modal.hide();
  }
}
